/* eslint-disable react/require-default-props */
import React, { FC, useState } from 'react'
import { TextFieldProps } from '@mui/material'
import TokTokDocAutocomplete from './Autocomplete'
import useDataSearch from '../../hooks/useDataSearch'

type DataSearchProps = {
    searchDataFunction: (s: string) => Promise<any>
    renderOption: (option: string | undefined) => string
    onDataSelected: (data: any) => void
    initialValue: any
    error?: boolean
    label: string
    disabled: boolean
    variant: TextFieldProps['variant']
    id: string
    className: string
    dataCy: string
}

const DataSearch: FC<DataSearchProps> = ({
    searchDataFunction,
    renderOption,
    onDataSelected,
    initialValue,
    error = false,
    label,
    disabled,
    variant,
    id,
    className,
    dataCy,
}) => {
    /* ### STATE ### */
    const [searchText, setSearchText] = useState('')
    const [value, setValue] = useState('')
    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([])
    const { patients, loading } = useDataSearch({
        searchText,
        value,
        searchDataFunction,
    })

    /* ### EFFECTS ### */
    React.useEffect(() => {
        if (!open) {
            if (initialValue) {
                // @ts-expect-error TS(2322) FIXME: Type 'any' is not assignable to type 'never'.
                setOptions([initialValue])
                setValue(initialValue)
            } else {
                setOptions([])
                setValue('')
            }
        }
        if (!loading && patients && patients?.length) {
            setOptions(
                // @ts-expect-error TS(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
                patients.map((patient) => ({
                    // @ts-expect-error TS(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
                    ...patient,
                })),
            )
        } else {
            setOptions([])
        }
    }, [open, loading, patients, searchText, value, initialValue])

    /* ### HANDLERS ### */

    /**
     * @description Callback called when value is selected
     * @param {Object} event
     * @param {Object} newValue
     * @returns {void}
     */
    const onAutocompleteChange = (event: any, newValue: any) => {
        setSearchText(newValue)
    }

    /**
     * @description Callback called when searchText/input change
     * @param {Object} event
     * @param {Object} newValue
     * @returns {void}
     */
    const onSelectedAutocomplete = (event: any, newValue: any) => {
        // @ts-expect-error TS(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
        setOptions(newValue ? [newValue, ...options] : options)
        setValue(newValue)
        onDataSelected(newValue)
    }

    return (
        <TokTokDocAutocomplete<string>
            id={id}
            searchText={searchText}
            value={value}
            setOpen={setOpen}
            options={options}
            loading={loading}
            error={error}
            renderOption={renderOption}
            onAutocompleteChange={onAutocompleteChange}
            onSelectedAutocomplete={onSelectedAutocomplete}
            label={label}
            disabled={disabled}
            variant={variant}
            className={className}
            dataCy={dataCy}
        />
    )
}

export default DataSearch
